<script setup>
import BackgroundSection from './BackgroundSection.vue'
import content from '../content.js'

const investment = content.investment
</script>

<template>
  <BackgroundSection
    section-id="investment"
    :video="investment.video"
    :image="investment.image"
    overlay-class="bg-black/60"
    extra-class="text-center"
  >
    <div class="max-w-4xl mx-auto px-6">
      <h2 class="text-2xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 text-shadow" data-aos="fade-up">
        {{ investment.title }}
      </h2>
      <p class="text-sm sm:text-lg md:text-xl leading-relaxed"
         data-aos="fade-up"
         data-aos-delay="200">
        {{ investment.text }}
      </p>
    </div>
  </BackgroundSection>
</template>
